module.exports = __webpack_public_path__ + "d96e58fac80a1589a76871d907adb3aa.svg";